export default {
  state: {
    tncReport: {
      show: false
    }
  },
  mutations: {
    showTNCReport (state) { state.tncReport.show = true },
    hideTNCReport (state) { state.tncReport.show = false }
  }
}



// WEBPACK FOOTER //
// ./src/store/reports/reports-tnc.js